module.exports = __webpack_public_path__ + "static/media/closed.4d6ce711.svg";